module.exports = __webpack_public_path__ + "assets/RegularBraces.34675138f90b6c1e484bc09e0c478afd.png";